
export default function(o, onQueryChange){

  var lang = o.store('lang')

  var click = function(buttonDecade, currentDecade){
    if(buttonDecade == currentDecade){
      return null
    } else {
      return function(){
        onQueryChange(null, buttonDecade)
      }  
    }
  }

  var advancedClick = function(){
    window.open('/admin','_self')
  }

  var buttonsDiv = $('<div>')

  var update = function(decade){

    var fortiesLabel = o.util.getTranslation(o, 'forties')
    var fiftiesLabel = o.util.getTranslation(o, 'fifties')
    var sixtiesLabel = o.util.getTranslation(o, 'sixties')
    var seventiesLabel = o.util.getTranslation(o, 'seventies')
    var eightiesLabel = o.util.getTranslation(o, 'eighties')
    var ninetiesLabel = o.util.getTranslation(o, 'nineties')
    var allLabel = o.util.getTranslation(o, 'all')

    var allDiv = o.component.button(o, allLabel, click('all', decade))
    var fortiesDiv = o.component.button(o, fortiesLabel, click(40, decade))
    var fiftiesDiv = o.component.button(o, fiftiesLabel, click(50, decade))
    var sixtiesDiv = o.component.button(o, sixtiesLabel, click(60, decade))
    var seventiesDiv = o.component.button(o, seventiesLabel, click(70, decade))
    var eightiesDiv = o.component.button(o, eightiesLabel, click(80, decade))
    var ninetiesDiv = o.component.button(o, ninetiesLabel, click(90, decade))

    buttonsDiv
    .empty()
    .append([
      allDiv,
      fortiesDiv,
      fiftiesDiv,
      sixtiesDiv,
      seventiesDiv,
      eightiesDiv,
      ninetiesDiv,
    ])

    var advancedLabel = o.util.getTranslation(o, 'advanced')

    if(o.store('token')){
      buttonsDiv
      .append([
        o.component.spacer(o),
        o.component.button(o, advancedLabel, advancedClick),
      ])
    }

  }

  var div =
    $('<div>')
    .addClass('menu')
    .css({
      textAlign: 'center',
      whiteSpace: 'nowrap',
      overflowY: 'auto',
      '-webkit-overflow-scrolling': 'touch',
      fontSize: o.fontSizeDef.s,
      padding: "0.8rem",
    })
    .append(buttonsDiv)

  if(!o.isTouch){
    div.mousemove(function(e){
      div.scrollLeft(
        e.pageX / div.width() * (div[0].scrollWidth - div.width()) + 20
      )
    })
  }

  div.update = update

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/archive/decade/decade.js